class ValidacaoForm {
    constructor(id_input) {
        const inputs = {
            'nm': 'nm_span',
            'nm_pai': 'span_nm_pai',
            'nm_mae': 'span_nm_mae',
            'rg': 'span_nm_rg',
            'nm_rgconjuge': 'span_rg_conjuge',
            'rg_responsavel': 'span_nm_rg_responsavel',
            'nm_conjuge': 'span_nm_conjuge',
            'nm_contato': 'span_nm_contato',
            'nm_cpfcontato': 'span_nm_cpfcontato',
            'celular': 'span_nm_celular',
            'nm_celular': 'span_nm_celular',
            'nm_nacionalidade': 'span_nm_nacionalidade',
            'nm_profissao': 'span_nm_profissao',
            'nm_nacionalidadeconjuge': 'span_nm_nacionalidadeconjuge',
            'nm_profissaoconjuge': 'span_nm_profissaoconjuge',
            'nm_apelido': 'span_nm_apelido',
        };
        this.id_input = inputs[id_input];
    }

    validaPassword(password) {
        const strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\W_])(?=.{6,})/;
        return strongRegex.test(password);
    }


    validaCamposCadastroNomes(campos, qtd = 3) {
        const camposReport = document.getElementById(this.id_input);

        if (camposReport != null) {
            if (!campos || campos.length < qtd) {
                camposReport.style.fontSize = '14px';
                camposReport.style.color = 'red';
                camposReport.innerHTML = 'Mínimo de caracteres não atingido.';
                return false;
            }

            camposReport.innerHTML = '';
            return true;
        }

        return campos && campos.length >= qtd;
    }

    verificaMaiorIdade(idade) {
        const dataAtual = new Date();
        const dataNascimento = new Date(idade);

        const diffAnos = dataAtual.getFullYear() - dataNascimento.getFullYear();
        const diffMeses = dataAtual.getMonth() - dataNascimento.getMonth();
        const diffDias = dataAtual.getDate() - dataNascimento.getDate();

        if (diffAnos < 18) {
            return false;
        }

        if (diffAnos >= 100) {
            return false;
        }

        if (diffAnos === 18 && (diffMeses < 0 || (diffMeses === 0 && diffDias < 1))) {
            return false;
        }

        if (diffAnos === 100 && (diffMeses > 0 || (diffMeses === 0 && diffDias > 1))) {
            return false;
        }

        return true;
    }

    verificaDataCasamento(data) {
        const dataAtual = new Date();
        const dataCasamento = new Date(data);

        if (dataCasamento > dataAtual) {
            return false;
        }

        const diffAnos = dataAtual.getFullYear() - dataCasamento.getFullYear();

        if (diffAnos > 100) {
            return false;
        }

        if (diffAnos === 100) {
            const diffMeses = dataAtual.getMonth() - dataCasamento.getMonth();
            if (diffMeses < 0) {
                return false;
            }

            if (diffMeses === 0) {
                const diffDias = dataAtual.getDate() - dataCasamento.getDate();
                if (diffDias < 0) {
                    return false;
                }
            }
        }

        return true;
    }


    estiloPosCod() {
        const estale = document.querySelector('#codigo_conf');
        if (estale.value.length != 0) {
            estale.addEventListener('keyup', () => {
                estale.classList.add('pos-cod');
            });
        } else if (estale.value == '') {
            estale.addEventListener('change', () => {
                estale.classList.remove('pos-cod');
            });
        }
    }
}

export default ValidacaoForm;